import { render, staticRenderFns } from "./Step2-Type2-Content.vue?vue&type=template&id=0d556b80&"
import script from "./Step2-Type2-Content.vue?vue&type=script&lang=js&"
export * from "./Step2-Type2-Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports